export default __webpack_public_path__ + "static/media/romulus.6bd238d7.ttf";